var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("字段配置(选择不可见的字段)"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 800
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, _vm._l(_vm.list, function (item2, index2) {
    return _c("a-checkbox", {
      key: index2,
      attrs: {
        checked: item2.selected
      },
      on: {
        change: function ($event) {
          return _vm.onChange(item2);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item2.name)) + " ")]);
  }), 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };